// import Cookies from "js-cookie";
import Vue from 'vue';
import cloneDeep from 'lodash/cloneDeep';
import Compressor from 'compressorjs';
import { message } from '@/utils/validate';
// import { uploadFile } from '@/api/upload.js';

export const parseUrlToObject = function(urlStr) {
  const res = {};

  if (urlStr) {
    const urlParmArr = urlStr.split('?');

    if (urlParmArr.length >= 2) {
      const parmArr = urlParmArr[1].split('&');

      for (const i in parmArr) {
        const item = parmArr[i];

        if (item) {
          const keyValueArr = item.split('=');

          if (keyValueArr.length == 2) {
            if (keyValueArr[1]) {
              res[keyValueArr[0]] = keyValueArr[1];
            }
          }
        }
      }
    }
  }
  return res;
};
// 图片压缩处理
export const clone = function(object) {
  return cloneDeep(object);
};
export function itemOccurrenceNumber(list, test) {
  var brr = [];

  for (let i = 0; i < list.length; ) {
    let count = 0;

    for (let j = i; j < list.length; j++) {
      if (list[i][test] == list[j][test]) {
        count++;
      }
    }
    let obj = {
      title: list[i][test],
      num: count
    };

    brr.push(obj);
    i += count;
  }
  return brr;
}
export function deepCopy(target) {
  if (typeof target == 'object') {
    const result = Array.isArray(target) ? [] : {};
    for (const key in target) {
      if (typeof target[key] == 'object') {
        result[key] = deepCopy(target[key]);
      } else {
        result[key] = target[key];
      }
    }

    return result;
  }

  return target;
}

export function swap(arr, i, j) {
  const temp = arr[i];
  arr[i] = arr[j];
  Vue.set(arr, i, arr[j]);
  Vue.set(arr, j, temp);
}

export function $(selector) {
  return document.querySelector(selector);
}
//数组位置互换
export function swapArray(arr, inx1, inx2) {
  arr[inx1] = arr.splice(inx2, 1, arr[inx1])[0]
}